import { useSelector } from 'react-redux'
import { Element } from '../../../../../../common/html/element'
import { LOCATION_TYPE } from '../../../../common/constant'
import { selectCriteria } from '../../../store/slice'
import { SelectedItem } from './SelectedItem'

export const SelectedLocation = ({ criteriaGroup, screeningIndicatorId }) => {
  const selectedData =
    useSelector(
      selectCriteria([criteriaGroup, screeningIndicatorId, 'data']),
    ) || []

  return (
    <Element>
      {selectedData.map((province) => (
        <Element key={province.Province.LocationId} className="dFlex">
          <Element className="mr1" style={{ width: 'calc((100% - 8px) / 2)' }}>
            <SelectedItem
              criteriaGroup={criteriaGroup}
              screeningIndicatorId={screeningIndicatorId}
              locationType={LOCATION_TYPE.PROVINCE}
              locationId={province.Province.LocationId}
            />
          </Element>
          <Element style={{ flex: 1 }}>
            {province.Province.Districts.map((district) => (
              <Element key={district.LocationId} className="dFlex gap1">
                <Element className="flex1">
                  <SelectedItem
                    criteriaGroup={criteriaGroup}
                    screeningIndicatorId={screeningIndicatorId}
                    locationType={LOCATION_TYPE.DISTRICT}
                    locationId={district.LocationId}
                  />
                </Element>
              </Element>
            ))}
          </Element>
        </Element>
      ))}
    </Element>
  )
}
